import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			adPosConfig: {
				homeRecommand: [1, 2, 3],
				homeRecommandPC: [3],
			},
			adsensConfig: {},

			domainConfig: {
				siteName: 'Get Approved, Drive Away',
				designType: 1,
				siteIcon: '/icon/1.svg',
				IAMEMAIL: 'contact@carsloansapproved.com',
				IAmURL: 'carsloansapproved.com',
				ABOUTUS: 'Get your car loan approved quickly with our trusted resources and guides.',
				meta: {
					title: 'Fast approvals to get you on the road',
					des: 'Experience swift approvals with our service, ensuring you can hit the road without unnecessary delays.',
				},
				firebase: {
					apiKey: 'AIzaSyBal6oqqvB2XIcHHfP3epuvS3GMrr9dhYs',
					authDomain: 'web-pub-3195-1.firebaseapp.com',
					projectId: 'web-pub-3195-1',
					storageBucket: 'web-pub-3195-1.firebasestorage.app',
					messagingSenderId: '716333800842',
					appId: '1:716333800842:web:520c1a590786c483f03c73',
					measurementId: 'G-6HEWZB4XVR',
				},
				ads: 'google.com, pub-9524345982013195, DIRECT, f08c47fec0942fa0',
				adsense: {
					scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9524345982013195',
					home_1: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '7608773495',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					home_2: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '2468692103',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					home_3: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '4134247121',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					home_4: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '4193956878',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					home_5: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '7881920446',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					cal_1: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '5255757100',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					cal_2: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '9027195746',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					cal_3: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '4896379049',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					detail_1: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '8900037385',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					detail_2: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '1376221840',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					detail_3: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '4465968353',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					all_1: {
						style: 'display:block',
						'data-ad-client': 'ca-pub-9524345982013195',
						'data-ad-slot': '1648233320',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					all: [
						{
							style: 'display:block',
							'data-ad-client': 'ca-pub-9524345982013195',
							'data-ad-slot': '1484867205',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
							class: 'adsbygoogle',
						},
						{
							style: 'display:block',
							'data-ad-client': 'ca-pub-9524345982013195',
							'data-ad-slot': '5810005468',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
							class: 'adsbygoogle',
						},
					],
				},
			},
			glossary: [],
			subprimeLendingInstitutions: [],
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			setGlossary(state, glossary) {
				state.glossary = glossary
			},
			setSubprimeLendingInstitutions(state, subprimeLendingInstitutions) {
				state.subprimeLendingInstitutions = subprimeLendingInstitutions
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			glossary: (state) => state.glossary,
			subprimeLendingInstitutions: (state) => state.subprimeLendingInstitutions,
		},
	})
}
